module.exports = __webpack_public_path__ + "img/roman.909aa421.jpg";